/**
 * What the assistant does, one part at a time, from the launch page. The first screen shows the
 * assistant's picture; the others an icon for their part. Like the web app's tour: a short title,
 * one line, and a few one-line points.
 */
export const getIntroSteps = (name) => [
  {
    id: "hello",
    title: "Your assistant in Addy",
    lede: `${name} reads your loans, shows its sources and does the busywork.`,
    note: "Nothing changes or gets sent until you approve.",
    points: [],
    tries: [],
  },
  {
    id: "ask",
    icon: "chat",
    title: "Ask about any loan",
    lede: "Ask in plain words. It reads the 1003, documents and tasks.",
    points: [
      { title: "Sources on every answer", text: "Click a number to open the page it came from." },
      { title: "Income and DTI", text: "See how income was calculated, or rerun the numbers." },
      { title: "Guidelines", text: "It quotes the agency rule it applied." },
      { title: "Your files", text: "Attach a PDF, or type @ to pick a loan document." },
    ],
    tries: ["How was income calculated?", "What's the DTI without the bonus?"],
  },
  {
    id: "work",
    icon: "file",
    title: "Hand off the work",
    lede: "Ask for the finished thing, not just an answer.",
    points: [
      { title: "Excel worksheets", text: "A real .xlsx, with formulas and sources." },
      { title: "Emails", text: "Written from your Gmail, sent only when you approve." },
      { title: "In your browser", text: "It works in your LOS while you watch." },
      { title: "Your other apps", text: "Connect Outlook, Calendar, Drive, Slack and more." },
    ],
    tries: ["Build an income worksheet in Excel", "Email the borrower about the missing paystub"],
  },
  {
    id: "away",
    icon: "clock",
    title: "Works while you're away",
    lede: "Set it once and it checks back on its own.",
    points: [
      { title: "Scheduled tasks", text: "Pick what to check and when." },
      { title: "Notifications", text: "Results land in your notification bell." },
      { title: "Answers finish", text: "Close the tab and the answer still arrives." },
    ],
    tries: ["Every weekday at 8am, list rate locks expiring this week"],
  },
  {
    id: "yours",
    icon: "mic",
    title: "Fits how you work",
    lede: "Type, talk, or pick up where you left off.",
    points: [
      { title: "Voice", text: "Tap the mic and talk." },
      { title: "Memory", text: "It learns your preferences. See or delete them anytime." },
      { title: "Chat history", text: "Every chat is saved. Search them from the sidebar." },
      { title: "Instructions", text: `See who ${name} is in Identity.` },
    ],
    tries: ["From now on, show DTI to two decimals"],
  },
  {
    id: "charge",
    icon: "shield",
    title: "You stay in charge",
    lede: "It does the legwork. You make the calls.",
    points: [
      { title: "Changes wait for you", text: "Nothing changes on a loan without your OK." },
      { title: "Emails need your OK", text: "You see the exact email before it's sent." },
      { title: "Stop means stop", text: "Press stop and it stops." },
      { title: "Everything is logged", text: "See every change, approval and email." },
    ],
    tries: [],
  },
];
